export default __webpack_public_path__ + "static/media/1939.b45029fc.png";